import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/index_bg.png'
import _imports_1 from '../assets/module2.png'
import _imports_2 from '../assets/module6.png'
import _imports_3 from '../assets/teacher.png'
import _imports_4 from '../assets/module3.png'
import _imports_5 from '../assets/module7.png'
import _imports_6 from '../assets/module1.png'
import _imports_7 from '../assets/aizhushou.png'
import _imports_8 from '../assets/background/module4.png'
import _imports_9 from '../assets/gonggao.png'
import _imports_10 from '../assets/index1.png'
import _imports_11 from '../assets/index2.png'
import _imports_12 from '../assets/index3.png'
import _imports_13 from '../assets/index4.png'
import _imports_14 from '../assets/index5.png'


const _withScopeId = n => (_pushScopeId("data-v-2e756f26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-r" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "swiper",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "total_number j-b f40 d-f p-r" }
const _hoisted_4 = { class: "c99 f24" }
const _hoisted_5 = { class: "f-w" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "在校总人数", -1))
const _hoisted_7 = { class: "c99 f24" }
const _hoisted_8 = { class: "f-w" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "教职工人数", -1))
const _hoisted_10 = { class: "c99 f24" }
const _hoisted_11 = { class: "f-w" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "教室总数", -1))
const _hoisted_13 = { class: "c99 f24" }
const _hoisted_14 = { class: "f-w" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "教学楼总数", -1))
const _hoisted_16 = { class: "module_ d-f c33 f24 p10" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_20 = {
  key: 2,
  src: _imports_3,
  alt: ""
}
const _hoisted_21 = {
  key: 3,
  src: _imports_4,
  alt: ""
}
const _hoisted_22 = {
  key: 4,
  src: _imports_5,
  alt: ""
}
const _hoisted_23 = {
  key: 5,
  src: _imports_6,
  alt: ""
}
const _hoisted_24 = {
  key: 6,
  src: _imports_7,
  alt: ""
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "更多应用", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "d-f j-b module" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "c33 f30" }, "我的待办"),
  /*#__PURE__*/_createElementVNode("div", { class: "c99 f24" }, "查看全部待办信息")
], -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "c33 f30" }, "我的申请"),
  /*#__PURE__*/_createElementVNode("div", { class: "c99 f24" }, "查看全部申请信息")
], -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "tabs" }
const _hoisted_37 = { class: "tab c99 f30 d-f" }
const _hoisted_38 = {
  key: 0,
  class: "campus t-l d-f j-b c33 f26"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 1,
  class: "campus t-l d-f j-b c33 f26"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 1,
  class: "list"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cff f24 p-a" }, "实训室预警", -1))
const _hoisted_45 = { class: "f32 cfc p-a" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f24 p-a" }, "实训室设备故障报警数量", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cff f24 p-a",
  style: {"background":"#247af1"}
}, "班牌预警", -1))
const _hoisted_49 = {
  style: {"color":"#247af1"},
  class: "f32 cfc p-a"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f24 p-a" }, "班牌离线预警信息查询", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"#52d0b1"},
  class: "cff f24 p-a"
}, " 仓储预警 ", -1))
const _hoisted_53 = {
  style: {"color":"#52d0b1"},
  class: "f32 cfc p-a"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f24 p-a" }, "工具数量、种类多拿信息查询", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1))
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作台", -1))
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的", -1))
const _hoisted_60 = ["src"]

import { moduleMenutf, authoritytf } from "@/utils/common";
import { ref, onMounted, onBeforeMount } from "vue";
import router from "@/router";
import {
  notice,
  mymessage,
  schooldata,
  checkUser,
  moduleMenu,
  permission,
  main,
  generalTrainingdeviceWarnselect,
  ecardselect,
  warningSelect,
} from "@/axios/index";
import { authorityfun, moduleMenufun } from "@/utils/common";
import Newrepair_detailstwo from "./trainingroom/newrepair_detailstwo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const warenoticelist = ref([]); //仓储
const dromnoticelist = ref([]); //归寝通告
const ecarnoticelist = ref([]); //班牌
const msglist = ref([]);
const mymessagetwo = ref<any>();
const tab = ref(1);
const tabsta = (val: any) => {
  tab.value = val;
};
const routersta = (val: any) => {
  if (val == "/api/app/ai") {
    window.open(val);
  } else {
    router.push({
      path: val,
    });
  }
};
const newdatas = ref<object>([]);
const mains = async () => {
  const { data }: any = await main({});
  if (data.code == 0) {
    newdatas.value = data.data;
    warenoticelist.value = data.data?.wareHouseNotifys;
    dromnoticelist.value = data.data?.dormNotifys;
    ecarnoticelist.value = data.data?.ecardNotifys;
  }
};
// 我的待办
const waittobedonesta = () => {
  router.push({
    path: "./approveList",
  });
};
// 我的申请
const handleapplyforList = () => {
  router.push({
    path: "./myapproveList",
  });
};
//写接口
// 登陆检测
const checkUsers = async () => {
  let { data }: any = await checkUser({});
  const newdata = ref<any>(data.data);
  console.log("登陆检测", data.data.need_login, data.data.need_login == false);
  if (data.data.need_login == false) {
    console.log("不需要登陆", data.data.apiadmin.account_type);
    if (data.data.apiadmin.account_type == 3) {
      console.log("身份家长", data.data.apiadmin.account_type);
      router.push({
        path: "./parentsPage",
      });
    } else {
      if (
        localStorage.getItem("oftenmoudeldata") == null ||
        localStorage.getItem("oftenmoudeldata") == "[]"
      ) {
        oftenmodel.value = [];
      } else {
        oftenmodel.value = [];
        let newoftenmodel = JSON.parse(localStorage.getItem("oftenmoudeldata"));
        const { data }: any = await moduleMenu({});
        let newdata = data.data.map((item: any) => {
          return item?.key;
        });
        newoftenmodel.forEach((item: any) => {
          if (newdata.includes(item.authority)) {
            oftenmodel.value.push(item);
            return;
          }
          if (item.authority == "/api/app/ai") {
            oftenmodel.value.push(item);
            return;
          }
        });
      }
      mains();
      const { data }: any = await moduleMenu({});
      moduleMenufun(data.data);
      const datas = await permission({});
      authorityfun(datas.data.data);
      localStorage.setItem("mymessage", JSON.stringify(newdata.value.apiadmin));
      mymessages();
      console.log("身份学校", newdata.value.apiadmin);
      if (
        authoritytf("admin.generaltraining.generaltrainingdevicewarn.select")
      ) {
        generalTrainingdeviceWarnselects();
      }
      if (authoritytf("admin.ecard.ecard.select")) {
        ecardselects();
      }
      if (authoritytf("admin.warehouse.warehousewarn.select")) {
        warningSelects();
      }
    }
  } else {
    console.log("需要登陆", data.data.need_login);
    localStorage.setItem("opneid", JSON.stringify(data.data.open_id));
    router.push({
      path: "./about",
    });
  }
};
// 我的消息
const mymessages = async () => {
  let { data } = await mymessage({});
  if (data.code == 0) {
    msglist.value = data.data;
  } else {
    alert(data.msg);
  }
};
// 实训室报警
const trainingroomcount = ref<number>(0);
const generalTrainingdeviceWarnselects = async () => {
  const { data }: any = await generalTrainingdeviceWarnselect({
    page: 1,
    limit: 10,
    event: 1,
  });
  if (data.code == 0) {
    trainingroomcount.value = data.count;
  }
};
// 电子班牌报警
const banpaicount = ref<number>(0);
const ecardselects = async () => {
  let { data } = await ecardselect({
    page: 1,
    limit: 10,
  });
  if (data.code == 0) {
    banpaicount.value = data.count;
  }
};
// 仓储报警
const warningcount = ref<number>(0);
const warningSelects = async () => {
  let { data } = await warningSelect({
    page: 1,
    limit: 10,
  });
  if (data.code == 0) {
    warningcount.value = data.count;
  }
};
const oftenmodel = ref<object>([]);
onBeforeMount(async () => {});
onMounted(() => {
  checkUsers();
  mymessagetwo.value = JSON.parse(localStorage.getItem("mymessage"));
});
// 动态css样式
const num = ref(1);
const border = ref(1);
// tabar
const active = ref(0);
const icon = {
  active: require("/src/assets/tab1.png"),
  inactive: require("/src/assets/tab1x.png"),
};
const icontab2 = {
  active: require("/src/assets/background/tab2.png"),
  inactive: require("/src/assets/background/tab2x.png"),
};
const icontab3 = {
  active: require("/src/assets/background/tab3.png"),
  inactive: require("/src/assets/background/tab3x.png"),
};
// 公告详情
const handelegonggao = () => {
  // router.push({
  //   path: "/noticeList",
  // });
  router.push({
    path: "/announcement",
  });
};
const handleapply = () => {
  router.push({
    path: "/applyforList",
  });
};
const handleapprove = () => {
  router.push({
    path: "/approveList",
  });
};
const handlewarehous = () => {
  router.push({
    path: "/smartLogistics",
  });
};
const handleadd = () => {
  router.push({
    path: "./staGing",
  });
};

return (_ctx: any,_cache: any) => {
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(newdatas.value?.studentCount), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(newdatas.value?.teacherCount), 1),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(newdatas.value?.roomCount), 1),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(newdatas.value?.buildCount), 1),
        _hoisted_15
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oftenmodel.value, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: item,
          class: "w25",
          onClick: ($event: any) => (routersta(item?.strs))
        }, [
          (item?.strs == 'smartLogistics')
            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
            : _createCommentVNode("", true),
          (item?.strs == 'classCard')
            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
            : _createCommentVNode("", true),
          (item?.strs == 'teacherhome')
            ? (_openBlock(), _createElementBlock("img", _hoisted_20))
            : _createCommentVNode("", true),
          (item?.strs == 'bedroomPage')
            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
            : _createCommentVNode("", true),
          (item?.strs == 'classroomIndex')
            ? (_openBlock(), _createElementBlock("img", _hoisted_22))
            : _createCommentVNode("", true),
          (item?.strs == 'training')
            ? (_openBlock(), _createElementBlock("img", _hoisted_23))
            : _createCommentVNode("", true),
          (item?.strs == '/api/app/ai')
            ? (_openBlock(), _createElementBlock("img", _hoisted_24))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(item?.text), 1)
        ], 8, _hoisted_17)), [
          [_vShow, _unref(moduleMenutf)(item?.authority)]
        ])
      }), 128)),
      _createElementVNode("div", {
        class: "w25",
        onClick: handleadd
      }, _hoisted_27)
    ]),
    (_unref(authoritytf)('admin.warehouse.warehousenotify.select'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "swperr",
          onClick: handelegonggao
        }, [
          _hoisted_28,
          _createVNode(_component_van_divider, {
            vertical: "",
            dashed: "",
            style: { borderColor: '#000000' }
          }),
          _createVNode(_component_van_swipe, {
            class: "my-swipe",
            "indicator-color": "#247AF1",
            vertical: "",
            autoplay: 3000
          }, {
            default: _withCtx(() => [
              (_unref(moduleMenutf)('warehouse'))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(warenoticelist.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                      style: {"position":"relative"},
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.created_at), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true),
              (_unref(moduleMenutf)('dorm'))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(dromnoticelist.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                      style: {"position":"relative"},
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.created_at), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true),
              (_unref(moduleMenutf)('ecard'))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(ecarnoticelist.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                      style: {"position":"relative"},
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.created_at), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", {
        onClick: waittobedonesta,
        class: "module_ d-f"
      }, _hoisted_32),
      (_unref(authoritytf)('admin.warehouse.warehouseapply.select'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: handleapplyforList,
            class: "module_ d-f"
          }, _hoisted_35))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tabsta(1))),
          class: _normalizeClass(tab.value == 1 ? 'tab_ c33 f30 f-w p-r' : '')
        }, " 校园风采 ", 2),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tabsta(2))),
          class: _normalizeClass(tab.value == 2 ? 'tab_ c33 f30 f-w p-r' : '')
        }, " 班级风采 ", 2)
      ]),
      (tab.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createVNode(_component_van_swipe, {
              class: "my-swipe",
              autoplay: 3000,
              "indicator-color": "white"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newdatas.value.shoolNews, (item) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"width":"100%"},
                        src: '/api' + item?.url,
                        alt: ""
                      }, null, 8, _hoisted_39)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (tab.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createVNode(_component_van_swipe, {
              class: "my-swipe",
              autoplay: 3000,
              "indicator-color": "white"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newdatas.value.classNews, (item) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"width":"100%"},
                        src: '/api' + item?.url,
                        alt: ""
                      }, null, 8, _hoisted_41)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (
        _unref(authoritytf)('admin.generaltraining.generaltrainingdevicewarn.select') ||
        _unref(authoritytf)('admin.ecard.ecard.select') ||
        _unref(authoritytf)('admin.warehouse.warehousewarn.select')
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          (
          _unref(authoritytf)('admin.generaltraining.generaltrainingdevicewarn.select')
        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "p-r",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (routersta('trainingroomalarmList')))
              }, [
                _hoisted_43,
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, "实训室报警:" + _toDisplayString(trainingroomcount.value), 1),
                _hoisted_46
              ]))
            : _createCommentVNode("", true),
          (_unref(authoritytf)('admin.ecard.ecard.select'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "p-r",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (routersta('banpaialarmList')))
              }, [
                _hoisted_47,
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, " 班牌预警:" + _toDisplayString(banpaicount.value), 1),
                _hoisted_50
              ]))
            : _createCommentVNode("", true),
          (_unref(authoritytf)('admin.warehouse.warehousewarn.select'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "p-r",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (routersta('alarmList')))
              }, [
                _hoisted_51,
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, " 仓储预警:" + _toDisplayString(warningcount.value), 1),
                _hoisted_54
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_tabbar, {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((active).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? icon.active : icon.inactive
            }, null, 8, _hoisted_56)
          ]),
          default: _withCtx(() => [
            _hoisted_55
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/staGing"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? icontab2.active : icontab2.inactive
            }, null, 8, _hoisted_58)
          ]),
          default: _withCtx(() => [
            _hoisted_57
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/myCenter"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? icontab3.active : icontab3.inactive
            }, null, 8, _hoisted_60)
          ]),
          default: _withCtx(() => [
            _hoisted_59
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})